export const environment = {
  production: true,
  buildId: '3939304487123971',
  configFile: 'config.json',
};
